import { ReceiptType } from 'matrix-js-sdk'
import { requireClient } from './client'

export function sendReadReceipt(roomId: string, eventId: string) {
  const client = requireClient()
  const room = client.getRoom(roomId)
  if (!room) return

  const event = room.findEventById(eventId)
  if (!event) return

  client.sendReadReceipt(event, ReceiptType.Read).catch(() => {})
}

export function markRoomAsRead(roomId: string) {
  const client = requireClient()
  const room = client.getRoom(roomId)
  if (!room) return

  const lastEvent = room.timeline[room.timeline.length - 1]
  if (!lastEvent) return

  client.sendReadReceipt(lastEvent, ReceiptType.Read).catch(() => {})
}
